"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNAVAILABLE_IMG_URL = exports.TRANSLATIONS = exports.IMAGE_NOT_FOUND = exports.IMAGE = exports.COLOR = exports.ALIGN = void 0;
var COLOR = {
  green: 'green',
  greenLight: 'greenLight',
  greyDark: 'greyDark',
  greyDarker: 'greyDarker',
  tertiary: 'tertiary',
  neutral: 'neutral'
};
exports.COLOR = COLOR;
var IMAGE_NOT_FOUND = 'Not Found';
exports.IMAGE_NOT_FOUND = IMAGE_NOT_FOUND;
var ALIGN = {
  center: 'center'
};
exports.ALIGN = ALIGN;
var UNAVAILABLE_IMG_URL = 'https://storage.googleapis.com/static.airasia.com/design/images/flight/seatUnavaialble.svg';
exports.UNAVAILABLE_IMG_URL = UNAVAILABLE_IMG_URL;
var IMAGE = {
  width: '280px',
  height: '152px'
};
exports.IMAGE = IMAGE;
var TRANSLATIONS = {
  soldoutTitle: 'Oh no! We just sold our last Flatbed :(',
  soldoutSubtitle: 'We will change your flight class to economy',
  soldoutEconomyCta: 'Switch to economy',
  soldoutSearchCta: 'Search another date'
};
exports.TRANSLATIONS = TRANSLATIONS;